import { instances } from './spinbutton';
import { DatePicker, DatePickerInput } from './datepicker';

let forms = Array.from(document.querySelectorAll('.js-book'));

export function init() {
	forms.forEach(form => {
		let site = form.elements['siteId'];
		let group = form.querySelector('.js-book-fields');

		let fields = {
			date: form.elements['date'],
			adults: form.elements['adults'],
			children: form.elements['children'],
		};

		let dpContainer = document.createElement('div');
		dpContainer.className = 'datepicker-modal';

		let datePickerInstance = DatePickerInput(fields.date, DatePicker({
			container: dpContainer,
		}));

		fields.date.after(dpContainer);

		form.addEventListener('submit', onSubmit);

		if (site) {
			site.addEventListener('change', onUpdateSite);
		}

		if (fields.children) {
			fields.children.addEventListener('spinbutton:change', onUpdateChildren);
		}

		onUpdateSite();
		onUpdateChildren();

		function onUpdateSite() {
			let adultsInputId = fields.adults.id;
			let childrenInputId = fields.children.id;

			let adultsSpinButton = instances[adultsInputId];
			let childrenSpinButton = instances[childrenInputId];

			let { options, selectedIndex } = site;
			let option = options[selectedIndex];

			if (option.value !== '1') {
				enable();
			} else {
				disable();
			}

			adultsSpinButton.setMax(option.dataset.maxAdults);
			childrenSpinButton.setMax(option.dataset.maxChildren);

			if (option.dataset.maxChildren > 0) {
				form.querySelector('.js-book-children').removeAttribute('hidden');
			} else {
				form.querySelector('.js-book-children').setAttribute('hidden', '');
			}
		}

		function enable() {
			group.style.opacity = '';
			getInputs().map(element => element.removeAttribute('disabled'));
		}

		function disable() {
			group.style.opacity = 0.5;
			getInputs().map(element => element.setAttribute('disabled', 'true'));
		}

		function getInputs() {
			return Array
				.from(form.querySelectorAll('input, select'))
				.filter(element => element.name !== 'siteId');
		}

		function onUpdateChildren() {
			let value = fields.children.value;

			let container = form.querySelector('.js-book-ages');
			let ages = Array.from(container.querySelectorAll('.js-book-age'));

			if (value > 0) {
				container.removeAttribute('hidden');
			} else {
				container.setAttribute('hidden', '');
			}

			function show(elem) {
				elem.removeAttribute('hidden');
			}

			function hide(elem) {
				elem.setAttribute('hidden', '');
			}

			ages.forEach((elem, i) => {
				i + 1 <= value ? show(elem) : hide(elem);
			});
		}

		let occupancy;

		function getOccupancyChildren(childrenCount) {
			let childAges = '';
			let ageUnit;

			for (let i = 0; i < childrenCount; i++) {
				i === 0 ? ageUnit = '' : ageUnit = '+';
				let bookingDrawId = i + 1;
				let ageField = document.getElementById(`booking-drawer-age-${bookingDrawId}`);
				let	ageValue = ageField.value;
				childAges += ageUnit + ageValue;
			}

			return childAges;
		}

		function getOccupancy(adults) {
			if (site.value === '2') {
				occupancy = adults;
				return occupancy;
			}

			if (site.value === '3') {
				let childrenCount = fields.children.value;
				let childAges = getOccupancyChildren(childrenCount);
				childrenCount > 0 ? occupancy = `${adults}+${childrenCount}#${childAges}` : occupancy = adults;
				return occupancy;
			}
		}

		function onSubmit(event) {
			event.preventDefault();

			let errors = [];
			let errorContainer = form.querySelector('.js-book-errors');

			let rules = [
				{
					field: site,
					rule: validateSite,
					message: 'Please select a hotel',
				},
				{
					field: fields.date,
					rule: validateDate,
					message: 'Date must be in dd/mm/yyyy format',
				},
			];

			for (let i = 0; i < rules.length; i++) {
				let fieldValid = rules[i].rule(rules[i].field);

				if (fieldValid) {
					continue;
				}

				errors.push(rules[i].message);
				rules[i].field.setAttribute('aria-invalid', 'true');
				rules[i].field.setAttribute('aria-describedby', `error-${i}`);
			}

			if (errors.length === 0) {
				let date = datePickerInstance.getCurrentDate();
				let d = String(date.getDate()).padStart(2, '0');
				let m = String(date.getMonth() + 1).padStart(2, '0');
				let y = date.getFullYear();

				let dateSelected = [y, m, d].join('-');

				let nights = form.elements['nights'].value;
				let adults = fields.adults.value;
				let occupancy = getOccupancy(adults);

				let roomId = form.elements['roomId'];
				let offerId = form.elements['offerId'];
				let promoCode = form.elements['promoCode'];

				// eslint-disable-next-line no-undef
				Booking.Open({
					checkin: dateSelected,
					nights: nights,
					occupancy: occupancy,
					Currency: 'GBP',
					RoomID: roomId ? roomId.value : '',
					OfferID: offerId ? offerId.value : '',
					promocode: promoCode ? promoCode.value : '',
				});

				return true;
			}

			errorContainer.innerHTML = '';

			for (let i = 0; i < errors.length; i++) {
				let li = document.createElement('li');
				li.id = `error-${i}`;
				li.className = 'error';
				li.textContent = errors[i];

				errorContainer.appendChild(li);
			}
		}

		function validateSite(field) {
			let { options, selectedIndex } = field;
			let option = options[selectedIndex];

			return (option.value != '' && option.value != '1');
		}

		function validateDate(field) {
			let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;

			return pattern.test(field.value);
		}
	});

	window.addEventListener('load', () => {
		var switcher = document.querySelectorAll('.c-switcher__tab');

		function myTabClicks(switcherClickEvent) {
			for (var i = 0; i < switcher.length; i++) {
				switcher[i].classList.remove('c-switcher__tab--active');
			}
			var clickedTab = switcherClickEvent.currentTarget;
			clickedTab.classList.add('c-switcher__tab--active');
			switcherClickEvent.preventDefault();
			var myContentPanes = document.querySelectorAll('.c-switcher__content--tab');
			for (i = 0; i < myContentPanes.length; i++) {
				myContentPanes[i].classList.remove('c-switcher__content--tab--active');
			}
			var anchorReference = switcherClickEvent.target;
			var activePaneId = anchorReference.getAttribute('href');
			var activePane = document.querySelector(activePaneId);
			activePane.classList.add('c-switcher__content--tab--active');
		}

		for (var i = 0; i < switcher.length; i++) {
			switcher[i].addEventListener('click', myTabClicks);
		}
	});

	var bedruthanRestaurantSelector = document.querySelector('.js-switch-booking-restaurant');
	if (bedruthanRestaurantSelector !== null) {
		bedruthanRestaurantSelector.addEventListener('change', (e) => {
			let src = 'https://booking.resdiary.com/widget/Standard/';
			let bookingFrame = document.querySelector('.c-frame--booking--bedruthan');
			let val = e.target.value;
			if (val == 0) {
				bookingFrame.classList.add('hidden');
			} else {
				bookingFrame.classList.remove('hidden');
				bookingFrame.src = src + val;
			}
		});
	}
}
